import React, { Component } from "react";
import { event } from "../analytics";

import i18n from '../../i18n';

import IconArrowImage from '../../images/shared/icon-arrow.png';
import IconBackgroundCheck from '../../images/shared/icon-background-check.png';
import IconFirstAid from '../../images/shared/icon-first-aid.png';
import IconRulesSeminar from "../../images/shared/icon-rules-seminar.png";
import IconMemberOk from "../../images/shared/icon-member-ok.png"
import IconSafeSport from "../../images/shared/icon-safesport.png";

const imagesHelper = {
  backgroundCheck: IconBackgroundCheck,
  firstAid: IconFirstAid,
  rulesSeminar: IconRulesSeminar,
  membershipOk: IconMemberOk,
  safeSport: IconSafeSport,
};

const docsNames = {
  membershipOk: i18n.t("certification.docs.names.membershipOk") ,
  firstAid: i18n.t("certification.docs.names.firstAid"),
  rulesSeminar: i18n.t("certification.docs.names.rulesSeminar"),
  backgroundCheck: i18n.t("certification.docs.names.backgroundCheck"),
  safeSport: i18n.t("certification.docs.names.safeSport")
};

const docsDescription = {
  membershipOk: i18n.t("certification.docs.descriptions.membershipOk"),
  firstAid: i18n.t("certification.docs.descriptions.firstAid"),
  rulesSeminar: i18n.t("certification.docs.descriptions.rulesSeminar"),
  backgroundCheck: i18n.t("certification.docs.descriptions.backgroundCheck"),
  safeSport: i18n.t("certification.docs.descriptions.safeSport")
};

class CertificationDocs extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <section className="row title-page">
          <div className="col-sm-12">
            <h1>{i18n.t("certification.docs.blackBeltCertification")}</h1>
          </div>
        </section>

        <section className="row">
          <div className="col-sm-12 col-md-2 first-col">
            <h5>{i18n.t("certification.docs.currentRequest")}</h5>
            <div className="options">
              <ul className="styled-list">
                <li>
                  {this.props.choosedOptions.certificateType === "new"
                    ? i18n.t("certification.docs.firstBlackBelt")
                    : i18n.t("certification.docs.updateBlackBelt")}
                </li>
                <li>{this.props.choosedOptions.country.label}</li>
              </ul>
            </div>
            <a
              href="/athletes/black-belt-certification"
              className="btn btn-outline-primary"
            >
              {i18n.t("certification.docs.changeRequest")}
            </a>
          </div>

          <div className="col-sm-12 col-md-1 d-none d-md-flex">
            <div className="divider"></div>
          </div>

          <div className="col-sm-12 col-md-9 second-col">
            <div className="row required-documents">
              <div className="col-sm-12">
                <h5>{i18n.t("certification.docs.requiredInfo")}</h5>
                <div className="row documents">
                  {this.props.docs.map((doc, idx) => {
                    return this.docItem(doc);
                  })}
                </div>
                <div className="row process-fee">
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="fee">
                      <h5 className="fee-title">{i18n.t("certification.docs.processFee")}</h5>
                      <span className="icon-arrow">
                        <img src={IconArrowImage} />
                      </span>
                      <span className="currency-fee">{`${
                        this.props.currency
                      } ${this.props.fee.toFixed(2)}`}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className="row timeline">
              <div className="col-sm-12">
                <h5>{i18n.t("certification.docs.steps.title")}</h5>

                <div className="row no-gutters steps-timeline">
                  <div className="col-md-3 step-one">
                    <div className="step">1</div>
                    <p className="step-description">
                      {i18n.t("certification.docs.steps.first")}
                    </p>
                  </div>

                  <div className="col-md-3 step-two">
                    <div className="step">2</div>
                    <p className="step-description">
                      {i18n.t("certification.docs.steps.second")}
                    </p>
                  </div>

                  <div className="col-md-3 step-three">
                    <div className="step">3</div>
                    <p className="step-description">
                      {i18n.t("certification.docs.steps.third")}
                    </p>
                  </div>

                  <div className="col-md-3 step-four">
                    <div className="step">4</div>
                    <p className="step-description">
                      {i18n.t("certification.docs.steps.fourth")}
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="row fill-your-membership">
              <div className="col-sm-12">
                <a
                  href={`${App.INFOSITE_APP_URL}/athletes/certificates/new`}
                  className="btn btn-outline-primary"
                  target="_blank"
                  onClick={() =>
                    event("Black Belt Certification", "Apply button click")
                  }
                >
                  {i18n.t("certification.docs.startOnlineApplication")}
                </a>
              </div>
            </section>
          </div>
        </section>
      </React.Fragment>
    );
  }

  docItem(doc) {
    return (
      <div className="col-sm-12 col-md-6 col-lg-4 doc mb-3">
        <figure>
          <img src={imagesHelper[doc]} className="img-fluid" />
          <figcaption>{docsNames[doc]}</figcaption>
        </figure>

        <div
          className="description text-left"
          dangerouslySetInnerHTML={{
            __html: docsDescription[doc]
          }}
        />
      </div>
    );
  }
}

export default CertificationDocs;
